<template>
  <SystemAnnouncementStack />
  <div class="flex flex-col min-h-screen">
    <Header />
    <main class="flex flex-col grow">
      <slot />
    </main>
    <Footer />
    
    <PermissionDeniedDialog 
      v-model:visible="permissionDeniedStore.visible" 
      :title="permissionDeniedStore.title" 
      :message="permissionDeniedStore.message" />
    
    <SubmissionErrorDialog 
      v-model:visible="submissionErrorStore.visible" 
      :title="submissionErrorStore.title" 
      :message="submissionErrorStore.message" 
      :errors="submissionErrorStore.errors" />
  </div>
</template>
<script setup>
import Header from './components/main/Header.vue'
import Footer from './components/main/Footer.vue'

import PermissionDeniedDialog from '@/components/common/PermissionDeniedDialog.vue'
import SubmissionErrorDialog from '@/components/common/SubmissionErrorDialog.vue'
import SystemAnnouncementStack from '@/components/system-announcements/SystemAnnouncementStack.vue'

import { usePermissionDeniedStore } from '@/stores/permissionDenied'
const permissionDeniedStore = usePermissionDeniedStore()

import { useSubmissionErrorStore } from '@/stores/submissionError'
const submissionErrorStore = useSubmissionErrorStore()

</script>
<style>
@import "@clubs/wusa-theme/theme.css";
@import "@/entrypoints/application.css"
</style>